import { Address } from 'viem';

export const NFT_BONDS: Address = '0xB805FF454b843fe860e454b9437979c832FAd22F';
export const NFT_REDEMPTION: Address =
  '0xaab73BF1977A0A83226dd1a761f2A0E29fC0b5f0';
export const REWARD_POOL: Address =
  '0xE5A61Cd197383335c6296f151398355dF06ad901';
